import { render } from "./SolucaoOutrosForm.vue?vue&type=template&id=5e9055e8"
import script from "./SolucaoOutrosForm.vue?vue&type=script&lang=js"
export * from "./SolucaoOutrosForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__